import React from 'react'
import ManageEmployers from 'components/ManageEmployers'
import PropTypes from 'prop-types'

const Home = props => (
  <div className="Home">
    <ManageEmployers isExternalUser={props.isExternalUser} />
  </div>
)

Home.propTypes = {
  isExternalUser: PropTypes.bool.isRequired
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/index.jsx